module.exports = __webpack_public_path__ + "img/PCAD_Prepurchased option_Website.d8910088.jpg";